import React from "react";
import { useDispatch, useSelector } from "react-redux";

import { Button, Tooltip } from "@mui/material";
import {
  TaskAlt as TaskAltIcon,
  Delete as DeleteIcon,
} from "@mui/icons-material";

import SubmitButton from "components/Button/SubmitButton";
import {
  toggleModal,
  toggleReportSigning,
} from "app/store/transmission/slice/transmissionSlice";
import { USER_ROLES } from "static/constants";
import { DATE_FORMAT } from "static/date";
import { formatLocalDateTime } from "utils/date";
import { getCurrentUserRole } from "utils/currentUser.util";

const SignStatus = () => {
  const dispatch = useDispatch();
  const userRole = getCurrentUserRole();

  const { reportDetail, isReportUnsigning } = useSelector(
    (state) => state.transmission
  );

  const handleUnsign = () => {
    dispatch(toggleReportSigning({ type: "unsign", value: true }));
    dispatch(toggleModal({ type: "unsign", value: true }));
  };

  return (
    <Tooltip
      title={
        <div style={{ display: "flex", alignItems: "center" }}>
          <span>
            Signed by {reportDetail?.signedBy?.name} on{" "}
            {formatLocalDateTime(
              reportDetail?.signed_at,
              DATE_FORMAT.FULL_DATE_TIME
            )}
          </span>
          {userRole !== USER_ROLES.ASSISTANT && (
            <>
              <div
                style={{
                  height: "20px",
                  width: "1px",
                  backgroundColor: "rgba(0, 0, 0, 0.3)",
                  margin: "4px 5px",
                }}
              />
              <SubmitButton
                variant="text"
                color="error"
                data-action="unsign-button"
                onClick={handleUnsign}
                disabled={isReportUnsigning}
                buttonText={<DeleteIcon />}
                onMouseDown={(e) => e.preventDefault()}
                onMouseEnter={(e) => {
                  e.currentTarget.querySelector("svg").style.color = "red";
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.querySelector("svg").style.color = "";
                }}
              />
            </>
          )}
        </div>
      }
      placement="bottom"
      interactive
    >
      <Button
        variant="contained"
        color="secondary"
        size="small"
        data-action="sign-button"
        startIcon={<TaskAltIcon />}
        style={{
          display: "flex",
          alignItems: "center",
          borderRadius: "20px",
        }}
      >
        Signed
      </Button>
    </Tooltip>
  );
};

export default SignStatus;
